import { render, staticRenderFns } from "./resendLink.vue?vue&type=template&id=4ae76b02&scoped=true&"
import script from "./resendLink.vue?vue&type=script&lang=js&"
export * from "./resendLink.vue?vue&type=script&lang=js&"
import style0 from "./resendLink.vue?vue&type=style&index=0&id=4ae76b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae76b02",
  null
  
)

component.options.__file = "resendLink.vue"
export default component.exports